module.exports = __webpack_public_path__ + "static/media/Unidav.eacbcd65.png";